/**
 * Created by Ning Jiang on 11/24/2016.
 */

import { ISoundConfig } from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import { IWinRatioConfig, WinRatioType } from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class BarbarianFurySoundConfig implements ISoundConfig {

    public static instance: BarbarianFurySoundConfig = new BarbarianFurySoundConfig();

    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";

    MAIN_GAME_AMBIANCE: string = "background-music-main";
    FREE_GAME_AMBIANCE: string = "background-music-fs";

    // REELS_SPIN_START:string = "reelsSpinning";
    REELS_SPINNING_START_ON_SPIN_START: string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    // REELS_DEFAULT_STOP?:string[];

    FS_THUNDER_STRIKE: string = "thunderStrike";

    //Respin sounds
    RESPIN_GRID_CLOSE: string = "respinGridCloses";
    RESPIN_GRID_EXPLODE: string = "respinGridExplode";
    RESPIN_TEASE_DOWN: string = "respinTeaseDown";
    RESPIN_NUDGE: string = "respinNudge";

    // bigWin Sound
    BIG_WIN: string = "bigwin";
    BIG_WIN_END: string = "bigwinEnds";

    // win sounds
    WIN_TINY: string = "winTiny";
    WIN_SMALL: string = "winSmall";
    WIN_MEDIUM: string = "winMedium";
    WIN_LARGE: string = "winLarge";
    BIGWIN_INITIAL_WIN: string = "bigwinInitialWin";

    COUNT_UP: string = "countup";
    COUNT_UP_ENDS: string = "countupEnds";
    MULTIPLIER_COUNT_UP_ENDS: string = "multiplierCountupEnds";
    MULTIPLIER_COUNT_UP: string = "multiplierCountup";

    // scatter sounds
    SCATTER: string = "scatter";
    SCATTER_LANDIG_FS: string = "scatterLandingFS";
    SCATTER_NUDGE: string = "scatterNudge";
    SCATTER_ANTICIPATION: string = "anticipation";
    SCATTER_ANTICIPATION_FAIL: string = "anticipationFail";

    // wild Sounds
    WILD_LANDING: string = "wildLanding";
    WILD_NUDGE: string = "wildNudge";
    WILD_NUDGE_NO_WIN: string = "wildNudgeNoWin";
    WILD_BEAR_ROAR: string = "wildBearRoar";
    WILD_BEAR_ROAR_SMALL: string = "wildBearRoarSmall";

    // IntroOutro
    FS_INTRO: string = "fsIntro";
    FS_END_SOUND: string = "fsEnds";





    constructor() {
        if (BarbarianFurySoundConfig.instance) {
            throw new Error("BarbarianFurySoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    static getNormalWinSoundName(winRatioConfig: IWinRatioConfig): any {
        if (!winRatioConfig) {
            return null;
        }
        switch (winRatioConfig.type) {
            case WinRatioType.TINY:
                return this.instance.WIN_TINY;
            case WinRatioType.SMALL:
                return this.instance.WIN_SMALL;
            case WinRatioType.MEDIUM:
                return this.instance.WIN_MEDIUM;
            case WinRatioType.LARGE:
                return this.instance.WIN_LARGE;
            default:
                return null;
        }
    }
}